import { c as _c } from "react/compiler-runtime";
import type { Entry } from "contentful";
import { getEntriesOfContentType, getEntry, isEntry } from "@/lib/contentful/guards";
import type { TypeTrustPropItemSkeleton } from "@/types/contentful/generated/TypeTrustPropItem";
import { ContentfulHelper } from "@/utils/ContentfulHelper";
import { useProductBuilderContext } from "./ProductBuilderContext";
type TrustPropItemEntry = Entry<TypeTrustPropItemSkeleton, undefined, string>;

/**
 * Converts a list of TrustPropItems into a list of objects containing the fields of each item,
 * parsing the icon field into the `ContentImage` type
 */
const resolveTrustPropItemFields = (trustPropItems: TrustPropItemEntry[]) => {
  return trustPropItems.map(item => {
    const {
      icon,
      ...restFields
    } = item.fields;
    const iconEntry = isEntry(icon) ? icon : undefined;
    const contentImage = iconEntry ? ContentfulHelper.parseContentfulContentImage(iconEntry.fields.media) : null;
    return {
      id: item.sys.id,
      icon: contentImage,
      ...restFields
    };
  });
};
export function useProductTrustProps() {
  const $ = _c(2);
  const {
    product
  } = useProductBuilderContext();
  let t0;
  if ($[0] !== product.trustProps) {
    const trustProps = getEntry(product.trustProps)?.fields;
    const trustPropItems = getEntriesOfContentType(trustProps?.items ?? [], "trustPropItem");
    t0 = resolveTrustPropItemFields(trustPropItems);
    $[0] = product.trustProps;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}